import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/context/CartContext";
import { AdminAuthProvider } from "@/context/AdminAuthContext";
import { SiteSettingsProvider } from "@/context/SiteSettingsContext";
import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import ShopPage from "@/pages/ShopPage";
import ProductPage from "@/pages/ProductPage";
import BundlesPage from "@/pages/BundlesPage";
import TeamOrdersPage from "@/pages/TeamOrdersPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import CartPage from "@/pages/CartPage";
import SuccessPage from "@/pages/SuccessPage";
import GripsPage from "@/pages/GripsPage";
import GripDetailPage from "@/pages/GripDetailPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import useLenis from "@/hooks/useLenis";

const SmoothScroll = ({ children }) => {
  useLenis();
  return children;
};

const StorefrontRoutes = () => (
  <Layout>
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/shop" element={<ShopPage />} />
      <Route path="/product/:slug" element={<ProductPage />} />
      <Route path="/bundles" element={<BundlesPage />} />
      <Route path="/team-orders" element={<TeamOrdersPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/cart" element={<CartPage />} />
      <Route path="/success" element={<SuccessPage />} />
      <Route path="/grips" element={<GripsPage />} />
      <Route path="/grips/:slug" element={<GripDetailPage />} />
      <Route path="*" element={<HomePage />} />
    </Routes>
  </Layout>
);

const Shell = () => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin");
  if (isAdminRoute) {
    return (
      <Routes>
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route path="/admin" element={<AdminDashboardPage />} />
      </Routes>
    );
  }
  return <StorefrontRoutes />;
};

function App() {
  return (
    <AdminAuthProvider>
      <SiteSettingsProvider>
        <CartProvider>
          <BrowserRouter>
            <SmoothScroll>
              <Shell />
            </SmoothScroll>
          </BrowserRouter>
          <Toaster
            position="bottom-right"
            toastOptions={{
              style: {
                borderRadius: 0,
                border: "1px solid #E5E5E5",
                background: "#fff",
                color: "#0A0A0A",
              },
            }}
          />
        </CartProvider>
      </SiteSettingsProvider>
    </AdminAuthProvider>
  );
}

export default App;
